import { axiosWithToken } from '../../../utils/axios';

export interface Station {
  id: number;
  global_id: number;
  lat: number;
  lon: number;
  area_input: number;
  basin_name: string;
  station_name: string;
  river_name: string;
  warn1: number;
  warn2: number;
  warn3: number;
  warn4: number;
  warn5: number;
}

export interface RivfldDepth {
  station_id: number;
  global_id: number;
  lat: number;
  lon: number;
  area_input: number;
  basin_name: string;
  station_name: string;
  river_name: string;
  analysis_results: {
    analysis_at: string;
    time: string;
    duration: number;
    depth: number;
  }[];
}

export type StationsType = {
  stations: Station[];
};

export async function getStations():Promise<Station[] | null>  {
  try {
    const { data }: { data: StationsType } = await axiosWithToken.get(`/stations/`, { data: {}, isToken: true });
    if (data.stations) {
      return data.stations;
    }
    return null;
  } catch (error) {
    return null ;
  }
}

export async function getRivfldDepth(stationId: number): Promise<RivfldDepth | null> {
  try {
    const { data }: { data: RivfldDepth } = await axiosWithToken.get(`/stations/${stationId}/rivfld_depth/`, { data: {}, isToken: true });
    if (data) {
      return data;
    }
    return null;
  } catch (error) {
    return null ;
  }
}
